/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LockOpenIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function LockOpenIcon({
  children,
  viewPath = "/DesignSystem/Svgs/LockOpenIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 32,
  height = 32,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "none",
  stroke = "#474747"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="LockOpenIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 32 32"
 overflow="visible"
 style={{'--as-1-UwMPv': alignSelf,'--mt-2-UwMPv': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-UwMPv': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-UwMPv': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-UwMPv': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-UwMPv': opacity,'--w-10-UwMPv': typeof width === 'number' ? `${width}px` : width,'--h-11-UwMPv': typeof height === 'number' ? `${height}px` : height,'--a-7-UwMPv': isAnimated ? animation : "none",'--sd-8-UwMPv': isAnimated ? strokeDashoffset : 0,'--sd-9-UwMPv': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="LockOpenIcon.SvgPath"
  data-view-path={viewPath}
 strokeWidth={3}
 strokeMiterlimit={10}
 d="M24.3 29.1H7.7C6.2 29.1 5 27.9 5 26.4V19.7C5 18.2 6.2 17 7.7 17H24.2C25.7 17 26.9 18.2 26.9 19.7V26.4C27 27.9 25.8 29.1 24.3 29.1Z"
 style={{'--f-12-UwMPv': fill,'--s-13-UwMPv': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
<path
  data-testid="LockOpenIcon.SvgPath:1"
  data-view-path={viewPath}
 strokeWidth={3}
 strokeMiterlimit={10}
 d="M6.99999 11.5144L8.29153 7.74373C9.18727 5.1286 13.3124 4.16323 17.4847 5.59233C21.657 7.02144 24.324 10.3133 23.4282 12.9284L22.1367 16.6991"
 style={{'--f-12-UwMPv': fill,'--s-13-UwMPv': stroke}}
 className={`views-block ${styles.SvgPath1}`}
/>
</svg>
{children}
</React.Fragment>)
}